import { render, staticRenderFns } from "./AgencyAdd.vue?vue&type=template&id=483b7b42&"
import script from "./AgencyAdd.vue?vue&type=script&lang=js&"
export * from "./AgencyAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports